import httpClient from "@/api/httpClient";
import AmenityCategoryResponse from "@/model/AmenityCategoryResponse";

function listAmenities(): Promise<AmenityCategoryResponse[]> {
  return httpClient.getJson<AmenityCategoryResponse[]>("/api/amenities");
}

const amenitiesApi = {
  listAmenities,
};

export default amenitiesApi;
